import { EventEmitter, Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import * as _ from "lodash";

@Injectable()
export class TreeListService implements OnDestroy {
  public readonly nodesSubject: BehaviorSubject<any[]> = new BehaviorSubject(
    []
  );
  public readonly nodesListed: EventEmitter<any[]> = new EventEmitter<any[]>();

  constructor() {}

  init(items) {
    this.nodes = [];
    this._refresh(items);
  }

  private _refresh(items) {
    // This method may be called multiple times. We must clear all subscriptions to avoid handling events multiple times.
    // this._clearEventSubscriptions();
    this.nodes = this._constructTreeNode(items, 0, []);
    this.nodesListed.emit(this.nodes);
  }

  ngOnDestroy() {}

  set nodes(nodes: any[]) {
    this.sortedNodes = nodes;
  }

  set sortedNodes(nodes: any[]) {
    this.nodesSubject.next(nodes);
  }

  get nodes(): any[] {
    return this.nodesSubject.value;
  }

  private _constructTreeNode(items, level, tree, parentId = null) {
    items.forEach((item) => {
      let node = {
        id: item.id,
        path: parentId ? parentId + "_" + item.id : 'ALL',
        name: item.item,
        level: level,
        expandable: false,
      };

      if (item.children.length > 0) {
        node.expandable = true;
        tree.push(node);
        tree = this._constructTreeNode(item.children, level + 1, tree, node.path);
      } else {
        tree.push(node);
      }
    });
    return tree;
  }
}
